import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import { PERMISSIONS } from '../../constants';
import HomeCarouselList from './HomeCarouselList';
import HomeCarouselCreate from './HomeCarouselCreate';
import HomeCarouselEdit from './HomeCarouselEdit';

export default {
  name: 'home-carousel',
  permissions: [PERMISSIONS.ADMIN],
  list: HomeCarouselList,
  create: HomeCarouselCreate,
  edit: HomeCarouselEdit,
  hasShow: false,
  hasEdit: true,
  icon: ViewCarouselIcon,
  options: { label: 'Imagens da Home' },
};
